export const cn = (...classes: (string | boolean | undefined)[]): string => classes.filter(Boolean).join(' ');
